import type { LocationQuery } from 'vue-router';
import { firstEntry } from '~/utils/firstEntry';
import type { ConfigurableOptionFragment } from '~/lib/Shop/generated/schema';
import { isDefined } from '~/utils/guards/isDefined';

export function createOptions(
  query: LocationQuery,
  availableOptions: ReadonlyArray<ConfigurableOptionFragment> = []
): Record<string, string> {
  const options: Record<string, string> = {};
  const definedAvailableOptions = availableOptions.filter(isDefined);

  for (const key in query) {
    const value = firstEntry(query[key]);
    const option = definedAvailableOptions
      .find((option) => option.attribute_code === key)
      ?.values?.find(
        // selected option can also be passed from product filter list
        // as the list does not know the uid, it will pass the label instead.
        (optionValue) =>
          optionValue?.uid === value || optionValue?.label === value
      );

    if (option?.uid) {
      options[key] = option.uid;
    }
  }

  return options;
}
